import { apiClient } from '@/services/api'
import endpoints from '@/services/endpoints'

export default {
  get: {
    // Detalles del usuario
    user: (id = 0) => {
      return {
        self: apiClient.get(endpoints.user(id).self),
        notifications: apiClient.get(endpoints.user(id).notifications),
      }
    },
    diy: () => {
      return {
        employees: apiClient.get(endpoints.diy().employees),
      }
    },
  },

  post: {
    passwordResetRequest: async (userEmail) => {
      try {
        const request = await apiClient.post(endpoints.user().passwordResetRequest, {
          email: userEmail,
        })
        return request
      } catch (error) {
        return error
      }
    },
  },

  patch: {
    updateUserInfo: async (userInfoObject) => {
      try {
        if (userInfoObject.avatar) {
          const request = await apiClient.patch(endpoints.user().self, userInfoObject)
          // apiClient.defaults.headers['Content-Type'] = 'application/json'
          return request
        } else {
          const request = await apiClient.patch(endpoints.user().self, userInfoObject)
          return request
        }
      } catch (error) {
        return error
      }
    },
  },
}
